import * as d3 from "d3";

/**
 * Draws a red dashed vertical line and stacked name labels for each target year.
 * Shared between InteractiveGlidepath and PortfolioGlidepath.
 */
export function renderTargetMarkerLines(
  svg: d3.Selection<SVGGElement, unknown, null, undefined>,
  markersByYear: Map<number, string[]>,
  x: d3.ScaleBand<string>,
  height: number
): void {
  markersByYear.forEach((names, targetYear) => {
    const xBand = x(String(targetYear)) ?? null;
    if (xBand === null) return;
    const cx = xBand + x.bandwidth() / 2;

    svg
      .append("line")
      .attr("x1", cx)
      .attr("x2", cx)
      .attr("y1", 0)
      .attr("y2", height)
      .attr("stroke", "#ef4444")
      .attr("stroke-width", 1.5)
      .attr("stroke-dasharray", "5,4");

    // Stack labels top-down, offset by 16px each to prevent overlap
    names.forEach((name, idx) => {
      svg
        .append("text")
        .attr("x", cx + 5)
        .attr("y", 14 + idx * 16)
        .attr("fill", "#ef4444")
        .style("font-size", "11px")
        .style("font-family", "Inter, sans-serif")
        .style("font-weight", "600")
        .text(name);
    });
  });
}
